import { createContext } from 'react';
import { IdpContextType } from '../../types';

export const IdentityContext = createContext<IdpContextType>({
  sessionId: void 0,
  user: null,
  isLoading: false,
  isSignedIn: true,
});
